module.exports = __webpack_public_path__ + "img/80.dda19b36.jpg";